// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueLazyload from "vue-lazyload";
import Mui from 'vue-awesome-mui';
import {getImg} from "./services/urlService";
import CryptoJS from "crypto-js";
import kkUtil from "./assets/js/kk-util";
import Axios from "axios";

Vue.config.productionTip = false;
let jsKey = CryptoJS.enc.Utf8.parse('ZVqAI6jw54IkfLZH');

Vue.use(VueLazyload, {
    adapter: {
      loaded(listener, Init) {
        let jsUrl = getImg(kkUtil.getJsPath(listener.el.getAttribute('imgpath')));
        Axios.create({
          headers: {
            'Content-Type': 'text/plain'
          },
        }).get(jsUrl).then(res => {
          if (res.status === 200) {
            listener.el.src = "data:image/png;base64," + kkUtil.aesDecrypt(res.data + "", jsKey);
          }else if (res.status === 204){
            listener.el.src = require('./assets/img/icon-e.png');
          }
        });
      }
    }
  },
  Mui);

/* eslint-disable no-new */
let vueObj = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js